<template>
  <with-actions>
    <div v-if="loaded && customer">
      <customer-form v-model="customer" v-on:save="create($event)"></customer-form>
      <template v-if="!is_demo_customer">
        <div class="row mt-4" v-if="is_migration">
          <div class="col-md-2 text-right">
            <h6 class="underline">{{ 'subscription' | t }}</h6>
          </div>
          <div class="col-md-8">
            <customer-creation-quote
              v-model="customer.subscription"
              :customer="customer"
              :clone="false"
              :override_features="true"
            ></customer-creation-quote>
          </div>
        </div>
        <div class="row mt-4" v-if="!customer.third_party_managed && !is_migration">
          <div class="col-md-2 text-right">
            <h6 class="underline">{{ 'quote' | t }}</h6>
          </div>
          <div class="col-md-8">
            <customer-creation-quote
              v-if="!is_demo_customer"
              v-model="customer.quote"
              :customer="customer"
              :clone="false"
            ></customer-creation-quote>
          </div>
        </div>
      </template>
      <div class="row mt-4">
        <div class="col-md-2 text-right"></div>
        <div class="col-md-5">
          <button class="btn btn-success btn-lg" @click="spin($event, save)">{{ 'create_customer' | t }}</button>
        </div>
      </div>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import { mapState } from 'vuex';
import store from '@/store';
import Alert, { handle } from '@/utils/alerts';
import $ from 'jquery';

export default {
  data: function () {
    return {
      customer: null,
      loaded: false
    };
  },
  computed: {
    ...mapState(['currentOrganization']),
    is_migration() {
      return this.$route.name == 'customers_migrate';
    },
    is_demo_customer() {
      return this.$route.name == 'customers_demo';
    }
  },
  methods: {
    get_customer() {
      return {
        name: '',
        tenant_name: '',
        address_1: '',
        address_2: '',
        city: '',
        zip: '',
        country_code: 'DK',
        state: '',
        vat_no: '',
        ean: '',
        customer_reference: '',
        admin_contact_email: '',
        admin_contact_name: '',
        admin_contact_phone: '',
        billing_contact_phone: '',
        billing_contact_email: '',
        billing_contact_name: '',
        currency: 'DKK',
        service_status: 'test',
        onboarding_status: 'onboarding',
        default_locale: 'da',
        payment_method: 'credit_card',
        login_method: 'password',
        default_ship_page: 'ship-orders',
        payment_term: null,
        crm_reference: '',
        third_party_managed: this.$store.state.currentOrganization
          ? this.$store.state.currentOrganization.is_managed
          : true,
        domains: [],
        subscription: null,
        quote: {
          status: 'quote',
          header_text: this.get_header_text('da'),
          name: '',
          plan_id: null,
          quote_lines: [],
          billing_period: 'monthly',
          usage_period: 'monthly',
          included_order_channels: 0,
          included_users: 0,
          included_printers: 0,
          included_carriers: 0,
          included_automations: 0,
          included_return_portals: 0,
          included_shipments: 0,
          included_locked_shipments: 0,
          price_shipments: 0,
          price_order_channels: 0,
          price_users: 0,
          price_printers: 0,
          price_automations: 0,
          price_return_portals: 0,
          price_carriers: 0,
          cancellation_periods: 1,
          currency: 'DKK',
          billing_product_id: '',
          payment_fee_percentage: 0,
          price: 0,
          bank_payment_fee: 0,
          level_one_support_price: 0,
          level_two_support_price: 0,
          level_three_support_price: 0,
          support_class: null,
          feature_scopes: null
        }
      };
    },
    get_subscription() {
      return {
        status: 'active',
        name: '',
        plan_id: null,
        quote_lines: [],
        billing_period: 'monthly',
        billing_period_start: new Date(),
        billing_period_end: new Date(),
        usage_period: 'monthly',
        usage_period_start: new Date(),
        usage_period_end: new Date(),
        included_order_channels: 0,
        included_users: 0,
        included_printers: 0,
        included_carriers: 0,
        included_automations: 0,
        included_return_portals: 0,
        included_shipments: 0,
        included_locked_shipments: 0,
        price_shipments: 0,
        price_order_channels: 0,
        price_users: 0,
        price_printers: 0,
        price_automations: 0,
        price_return_portals: 0,
        price_carriers: 0,
        cancellation_periods: 1,
        currency: 'DKK',
        billing_product_id: '',
        payment_fee_percentage: 0,
        price: 0,
        bank_payment_fee: 0,
        level_one_support_price: 0,
        level_two_support_price: 0,
        level_three_support_price: 0,
        support_class: null,
        feature_scopes: null
      };
    },
    get_header_text(locale) {
      let header_text = '';

      if (locale == 'da') {
        header_text = `Hej ${this.customer ? this.customer.admin_contact_name : ''},

Hvis du har spørgsmål så tøv ikke med at kontakte mig på ${this.staff.phone} eller ${this.staff.email}.

Venlig hilsen,
${this.staff ? this.staff.first_name : 'Webshipper'}`;
      } else {
        header_text = `Hi ${this.customer ? this.customer.admin_contact_name : ''},

If you have any questions, please don’t hesitate to contact me at ${this.staff.phone} or ${this.staff.email}.

All the best,
${this.staff ? this.staff.first_name : 'Webshipper'}
`;
      }

      return header_text;
    },
    save: handle(async function () {
      let newCustomer = _.cloneDeep(this.customer);
      newCustomer.sales_agent = _.cloneDeep(this.$store.state.staff);
      if (this.customer_type == 'migration') {
        newCustomer.onboarding_agent = _.cloneDeep(this.$store.state.staff);
      }

      if (newCustomer.third_party_managed || this.is_migration) {
        newCustomer.quote = null;
      }

      newCustomer.api_rate_limit = 80;
      newCustomer.api_rate_period_seconds = 40;

      let { data, errors, meta, links } = await Api.create('customers', newCustomer);

      this.$router.push({
        name: 'customers_show',
        params: { customer_id: data.id }
      });
    })
  },
  mounted() {
    this.customer = this.get_customer();

    if (this.is_demo_customer) {
      this.customer.quote = null;
      this.customer.subscription = null;
      this.customer.onboarding_status = 'demo';
    } else if (this.is_migration) {
      let now = new Date();
      // Set default activation time of beginning of day 3 months from now
      this.customer.quote.activation_time = new Date(new Date(now.setMonth(now.getMonth() + 3)).setHours(0, 0, 0, 0));
      this.customer.quote.is_forced = true;
      this.customer.subscription = this.get_subscription();
      this.customer.onboarding_status = 'migrating';
    } else {
      this.customer.onboarding_status = 'demo';
    }
    this.loaded = true;
  },
  watch: {
    'customer.admin_contact_name': function () {
      if (this.customer.quote) {
        this.customer.quote.header_text = this.get_header_text();
      }
    }
  }
};
</script>
